<template>
    <v-content>
        <v-container fluid>
            <h2 class="text-center my-2">{{ $t('ctaTitle') }}</h2>
            <v-row>
                <PlanCardCollapsed :key="'plan'+i" v-for="(info, i) in plans" :information="info" :properties="properties" :highlighted="highlight == undefined ? true : info.planName.toLowerCase().startsWith(highlight.toLowerCase())"/>
            </v-row>
        </v-container>

        <v-container fluid>
            <v-row align="center" justify="center">
                <v-btn class="my-2" @click="keepFreePlan" plain> {{ $t('keepFreePlan') }} </v-btn>
            </v-row>
        </v-container>

        <!--dialog!-->
        <v-dialog v-model="dialog" max-width="500">
            <v-card outlined>
                <v-card-title class="py-5 headline grey lighten-2 justify-center">
                    <h3>{{ dialogTitle }}</h3>
                </v-card-title>
                <v-card-text class="my-5 text-center justify-center">
                    <p>{{ dialogMessage }}</p>
                    <v-btn @click="dialog = false"> Ok </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-content>
</template>

<script>
    import PricingPlans from './pricingPlans';
    import PlanCardCollapsed from "./PlanCardCollapsed";
    import SubscriptionRepository from '../../../repositories/subscription';

    export default {
        name: "SubscriptionPlansCollapsed",
        components: {
            PlanCardCollapsed
        },
        props: {
            userId: Number,
            highlight: String,
            discount: Number,
        },
        data(){
            return {
                plans: [],
                properties: PricingPlans.properties.en,
                paypalButtonSize: 'Small',
                paypalButtonShape: 'pill',
                confirmationInfo: {
                    titleMessage: this.$t('confirmationInfo.titleMessage'),
                    bodyMessage: this.$t('confirmationInfo.bodyMessage'),
                    goToMessage: this.$t('confirmationInfo.goToMessage'),
                    afterConfirmationRoute: '',
                },
                dialog: false,
                dialogTitle: '',
                dialogMessage: '',
            }
        },
        watch: {
            '$i18n.locale': function(){
                this.refreshPricingPlans();
            }
        },
        mounted(){
            window.fbq('track', 'InitiateCheckout');
            this.plans = this.initializePlans();
            const script = document.createElement("script");
            script.src = this.$store.state.paypalSubscriptionsScript;
            script.addEventListener("load", this.renderPaypalButtons);
            document.body.appendChild(script);
            this.refreshPricingPlans();
        },
        methods:{
            initializePlans() {
                if(this.discount !== undefined) {
                    switch (this.discount) {
                        case 50:
                            return PricingPlans.information50Disc;
                        case 25:
                            return PricingPlans.information25Disc;
                        case 10:
                            return PricingPlans.information10Disc;
                        default:
                            return PricingPlans.information;
                    }
                } else {
                    return PricingPlans.information;
                }
            },
            refreshPricingPlans(){
                this.properties = (this.$i18n.locale==="en")?PricingPlans.properties.en:PricingPlans.properties.es;
            },
            renderPaypalButtons(){
                var elements = document.querySelectorAll('.paypal-button-container');
                for(let i = 0; i < elements.length; i++) {
                    if(this.plans[i].planName.includes('Lifetime')) {
                        window.paypal.Buttons({
                            style: {
                                size: this.paypalButtonSize,
                                color: this.plans[i].color,
                                shape: this.paypalButtonShape,
                            },
                            createOrder: (data, actions) => {
                                return actions.order.create({
                                    purchase_units: [
                                    {
                                        amount: {
                                        currency_code: "USD",
                                        value: this.plans[i].price.toString()
                                        }
                                    }]
                                });
                            },
                            onApprove: async (data, actions) => {
                                return actions.order.capture().then((details) => {
                                    let subInfo = {
                                        user_id: this.userId,
                                        subscription_id: data.orderID,
                                        plan_id: this.plans[i].planId
                                    };
                                    if(details.status == 'COMPLETED') {
                                        SubscriptionRepository.lifetimeSubscriptionCompleted(subInfo).then((response) => {
                                            if(response.status < 400){
                                                window.fbq('track', 'Purchase');
                                                this.$router.push({
                                                    name: 'confirmation',
                                                    params: { titleMessage: this.confirmationInfo.titleMessage,
                                                        bodyMessage: this.confirmationInfo.bodyMessage,
                                                        goToMessage: this.confirmationInfo.goToMessage,
                                                        afterConfirmationRoute: this.confirmationInfo.afterConfirmationRoute}
                                                });
                                            }
                                        });
                                    }
                                });
                            },
                            onError: () => {
                                this.dialogTitle = this.$t('somethingWentWrong_SubscriptionPlansCollapsed');
                                this.dialogMessage = this.$t('errorTryingToConnect_SubscriptionPlansCollapsed');
                                this.dialog = true;
                            }
                        }).render(elements[i]);
                    } else {
                        window.paypal.Buttons({
                            style: {
                                size: this.paypalButtonSize,
                                color: this.plans[i].color,
                                shape: this.paypalButtonShape,
                            },
                            createSubscription: (data, actions) => {
                                return actions.subscription.create({
                                    'plan_id': this.plans[i].planId
                                });
                            },
                            onApprove: async (data) => {
                                let subInfo = {
                                    user_id: this.userId,
                                    subscription_id: data.subscriptionID,
                                    plan_id: this.plans[i].planId
                                };
                                SubscriptionRepository.subscriptionApproved(subInfo).then((response) => {
                                    if(response.status < 400){
                                        window.fbq('track', 'Purchase');
                                        this.$router.push({
                                            name: 'confirmation',
                                            params: { titleMessage: this.confirmationInfo.titleMessage,
                                                bodyMessage: this.confirmationInfo.bodyMessage,
                                                goToMessage: this.confirmationInfo.goToMessage,
                                                afterConfirmationRoute: this.confirmationInfo.afterConfirmationRoute}
                                        });
                                    }
                                })
                            },
                            onError: () => {
                                this.dialogTitle = this.$t('somethingWentWrong_SubscriptionPlansCollapsed');
                                this.dialogMessage = this.$t('errorTryingToConnect_SubscriptionPlansCollapsed');
                                this.dialog = true;
                            }
                        }).render(elements[i]);
                    }
                }
            },
            keepFreePlan() {
                this.$router.push('/');
            }
        },
    }
</script>

<style scoped>

</style>


